import React, {useEffect, useState} from 'react';

import {DatasetCategoryDropdown} from 'components/basic/dropdowns/dataset-category/DatasetCategoryDropdown';
import DatasetUnitSelector from 'components/basic/dropdowns/dataset-unit-selector/DatasetUnitSelector';

import {InputText} from 'primereact/inputtext';
import {Dropdown} from 'primereact/dropdown';
import {Button} from 'primereact/button';
import {useCreateCategorizedDataset, useGetDefaultDatasetCategory} from 'api/api-hooks/datasets-hooks';
import {easasAlert} from 'components/fragments/easas-global-fragment/EasasGlobalAlerts';
import {BaseDatasetDTO} from 'api/model/dataset/BaseDatasetDTO';

const DATA_TYPES = [
    {
        label: 'Hourly',
        value: 'HOURLY',
    },
    {
        label: 'Daily',
        value: 'DAILY',
    },
    {
        label: 'Arbitrary',
        value: 'ARBITRARY',
    },
    {
        label: 'Monthly',
        value: 'MONTHLY',
    },
    {
        label: 'Weekly',
        value: 'WEEKLY',
    },
    {
        label: 'Seconds',
        value: 'SECONDS',
    },
    {
        label: 'Minutes',
        value: 'MINUTES',
    },
    {
        label: 'Arbitrary (minutes)',
        value: 'ARBITRARY_MINUTES',
    },
    {
        label: 'Arbitrary (seconds)',
        value: 'ARBITRARY_SECONDS',
    },
];

const ACCESS_TYPES = [
    {
        label: 'Normal',
        value: 'NORMAL',
    },
    {
        label: 'Continuous',
        value: 'CONTINUOUS',
    },
    {
        label: 'Data Model Day',
        value: 'DATA_MODEL_DAY',
    },
];

const CreateDatasetDialog = ({setCreateDialogVisibility}) => {
    const [unitSelectorValue, setUnitSelectorValue] = useState('');
    const [datasetTitle, setDatasetTitle] = useState('')
    const [dataType, setDataType] = useState("ARBITRARY")
    const [accessType, setAccessType] = useState("NORMAL")
    const [defaultCategory, setDefaultCategory] = useState<number | undefined>()

    const defaultCategoryQuery = useGetDefaultDatasetCategory();

    useEffect(() => {
        if (defaultCategoryQuery.isFetched) {
            setDefaultCategory(defaultCategoryQuery.data?.id);
        }
        if (defaultCategoryQuery.isError) {
            easasAlert("Error fetching category", '', 'error')
        }
    }, [defaultCategoryQuery.data]);

    const {mutate} = useCreateCategorizedDataset()

    function createDatasetHandler() {
        const data: Partial<BaseDatasetDTO> = {
            title: datasetTitle,
            categoryId: defaultCategory,
            dataType,
            accessType,
            unit: unitSelectorValue
        }

        mutate(data, {
            onSuccess: (data) => {
                easasAlert('DATASET CREATED', `${data.title} has been created`, 'success')
            },
            onError: (error) => {
                easasAlert('CREATION FAILED', `${error}`, 'error')
            }
        })
        setCreateDialogVisibility(false)
    }

    return (
        <div className='grid align'>
            <div className='flex col-12 align-items-center'>
                <p className='col-4 mb-0'>Category</p>
                <DatasetCategoryDropdown className="w-full" value={defaultCategory}
                                         onChange={(e) => setDefaultCategory(e)}/>
            </div>
            <div className='flex col-12 align-items-center'>
                <p className='col-4 mb-0'>Dataset Title</p>
                <InputText
                    className='w-full'
                    value={datasetTitle}
                    onChange={(e) => setDatasetTitle(e.target.value)}
                    placeholder={"New Dataset Title"}
                />
            </div>
            <div className='flex col-12 align-items-center'>
                <p className='col-4 mb-0'>Dataset Type</p>
                <Dropdown
                    className='w-full'
                    options={DATA_TYPES}
                    value={dataType}
                    onChange={(e) => setDataType(e.value)}
                    showClear
                />
            </div>
            <div className='flex col-12 align-items-center'>
                <p className='col-4 mb-0'>Data Type</p>
                <Dropdown
                    className='w-full'
                    options={ACCESS_TYPES}
                    value={accessType}
                    onChange={(e) => setAccessType(e.value)}
                    showClear
                />
            </div>
            <div className='flex col-12 align-items-center'>
                <p className='col-4 mb-0'>Unit</p>
                <DatasetUnitSelector
                    className='w-full'
                    value={unitSelectorValue}
                    onChange={(e) => setUnitSelectorValue(e)}
                />
            </div>
            <div className='flex col-12 gap-2'>
                <Button className='p-button-success' label='Create' onClick={createDatasetHandler}/>
                <Button className='p-button-danger' label='Cancel' onClick={() => setCreateDialogVisibility(false)}/>
            </div>
        </div>
    );
};

export default CreateDatasetDialog;
